import { useEffect, useState } from 'react';
import api, { catalogApi } from './api';
import { services as fallbackServices, options as fallbackOptions } from '../data/mock';

// Catalogue categories -> the 3 historic public groups ('vitres' | 'menage' | 'special')
const PUBLIC_GROUP = { vitres: 'vitres', veranda: 'vitres', locaux_pro: 'menage', menage: 'menage' };

const toPublicService = (s) => ({
  id: s.code,
  name: s.name,
  description: s.description,
  icon: s.icon,
  category: PUBLIC_GROUP[s.category] || 'special',
  ...(s.show_tax_badge ? { hasDeduction: true } : {}),
  ...(s.direct_booking ? { directBooking: true, optionCodes: s.option_codes || [] } : {}),
});
const toPublicOption = (o) => ({ id: o.code, name: o.name, description: o.description });

const FALLBACK = { services: fallbackServices, options: fallbackOptions };
let publicCache = null;
let publicRequest = null;

const loadPublic = () => {
  if (!publicRequest) {
    publicRequest = api.get('/services')
      .then(({ data }) => {
        if (!data?.services?.length) throw new Error('Catalogue vide');
        publicCache = { services: data.services.map(toPublicService), options: data.options.map(toPublicOption) };
        return publicCache;
      })
      .catch((err) => {
        console.warn('[catalogue] chargement impossible, liste par défaut utilisée', err?.message);
        publicRequest = null;
        return FALLBACK;
      });
  }
  return publicRequest;
};

/** Public catalogue: renders the historic list immediately, then the admin catalogue once loaded. */
export const useCatalog = () => {
  const [catalog, setCatalog] = useState(publicCache || FALLBACK);
  useEffect(() => {
    let alive = true;
    loadPublic().then((c) => alive && setCatalog(c));
    return () => { alive = false; };
  }, []);
  return catalog;
};

const toLabels = (items, key) => Object.fromEntries(items.map((i) => [i[key], i.name]));

/** Admin labels: historic names + every catalogue item (including inactive ones). */
export const useCatalogLabels = () => {
  const [labels, setLabels] = useState({
    services: toLabels(fallbackServices, 'id'),
    options: toLabels(fallbackOptions, 'id'),
  });
  useEffect(() => {
    Promise.all([catalogApi.list('services'), catalogApi.list('service-options')])
      .then(([s, o]) => setLabels((prev) => ({
        services: { ...prev.services, ...toLabels(s.data, 'code') },
        options: { ...prev.options, ...toLabels(o.data, 'code') },
      })))
      .catch(() => {});
  }, []);
  return labels;
};
